import { Drawer, Theme } from "@mui/material";
import { createStyles, makeStyles, withStyles } from "@mui/styles";

export const FilterDrawer = withStyles((theme: Theme) =>
  createStyles({
    paper: {
      top: "70px !important",
      width: 400,
      height: "90%  !important",
      marginRight: 8,
      borderRadius: 8,
    },
  })
)(Drawer);

export const useStyles = makeStyles((theme: Theme) => ({
  filterHeader: {
    position: "sticky",
    top: 0,
    display: "flex",
    padding: "0px 16px",
    justifyContent: "space-between",
    boxShadow: "0px 0px 5px 0px #cccccc",
    background: "#FFF",
    zIndex: "inherit",
  },
  filterFooter: {
    display: "flex",
    padding: 16,
    justifyContent: "space-between",
    boxShadow: "0px 0px 5px 0px #cccccc",
  },
  btnClose: {
    alignItems: "center",
    display: "flex",
  },
  body: {
    padding: 24,
    flex: "1 1 0%",
    overflow: "overlay",
  },
}));
